module.exports = __webpack_public_path__ + "img/download.38109884.svg";